import { useTranslation as useI18nTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { selectLanguage, changeLanguage } from '../features/language/languageSlice';
import { useEffect } from 'react';

export const useTranslation = () => {
  const { t, i18n } = useI18nTranslation();
  const currentLanguage = useSelector(selectLanguage);
  const dispatch = useDispatch();


  // Sync Redux state with i18n
  useEffect(() => {
    if (i18n.language !== currentLanguage) {
      i18n.changeLanguage(currentLanguage);
    }
  }, [currentLanguage, i18n]);

  // Sync i18n with Redux state
  useEffect(() => {
    if (i18n.language !== currentLanguage) {
      dispatch(changeLanguage(i18n.language as 'ar' | 'en'));
    }
  }, [i18n.language, currentLanguage, dispatch]);

  const changeLanguageHandler = async (language: 'ar' | 'en') => {
    
    // Update Redux store (this will update localStorage via the reducer)
    dispatch(changeLanguage(language));
    
    // Update i18n
    await i18n.changeLanguage(language);
    
  };

  return {
    t,
    currentLanguage,
    changeLanguage: changeLanguageHandler,
    isRTL: currentLanguage === 'ar',
  };
};

export default useTranslation;